import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Card, Form, Tabs, Button, Image, Offcanvas } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import auth from "../../actions/auth";
import news from "../../actions/news";
import {ReactComponent as QuestionSvg} from './../../assets/icons/svg/question.svg';
import { toast } from "react-toastify";

export default function PartnerDetail() {
  const { id } = useParams();
  const [user, setUser] = useState([]);
  const [mitra, setMitra] = useState([]);
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState(false);
  const [mitraFind, setMitraFind] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const handleCloseConfirm = () => setShowConfirm(false);
  const handleShowConfirm = () => setShowConfirm(true);
  const navigate = useNavigate();
  useEffect(() => {
   auth.actions.get_users().then((res)=>{
      setUser(res?.data)
      setMitraFind(res?.data?.partners.find(a => a.id === Number(id)))
      setLoading(false)
   });
   
   transaction.actions.get_partner_detail(id).then((res)=>{
      setMitra(res?.data);
      setLoading(false)
   });

   news.actions.get_news_partner(id).then((res)=>{
      setNewsList(res?.data?.data)
      setLoading(false)
   });
  },[])

  const contactAdmin = () => {
   var phones = mitra.phone
   if(phones[0] === '0'){
      phones = '+62' + phones.substring(1);
   }else{
      phones = mitra.phone
   }
   window.open(`https://wa.me/${phones}/?text=Halo ${mitra?.name}`, '_blank')
  }

  const onRequestJoin = () => {
   setLoad(true)
   let data = {
      partner_id: id
   }
   transaction.actions.post_request_join(data).then((res)=>{
      setLoading(false)
      toast.success('Berhasil, silahkan tunggu proses verifikasi')
      handleCloseConfirm();
      auth.actions.get_users().then((res)=>{
         setUser(res?.data)
         setMitraFind(res?.data?.partners.find(a => a.id === Number(id)))
         setLoading(false)
      });
   }).catch((err)=>{
      toast.error(err)
      handleCloseConfirm();
   });
  }
  
  const handlePickUp = () => {
   navigate('/trash/add');
  }

  return (
   <div className="bg-gray vh-100">
      <div className="bg-radial-green-short p-4">
         <div className="fixed-top header bg-radial-green-default">
            <div className="text-center fw-semibold text-light">
               Detail Mitra
            </div>
            <Button className="btn btn-icon btn-light btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
                  <i className="ph-arrow-left text-success"></i>
            </Button>
         </div>
         <h4 className={"pt-4 mt-5 text-light text-center "+(loading ? "skeleton skeleton-list":"")}>{mitra?.name}</h4>
         <Row className="mt-2 p-3">
            <Card className="card-smooth-shadow-top px-0">
               <Card.Body>
                  <Row>
                     <Col xs={6}>
                        <div className="text-smooth ts-xs">Total Nasabah Dilayani</div>
                        <h4 className={"text-light "+(loading ? "skeleton skeleton-h":"")}>{mitra?.clients?.length}</h4>
                     </Col>
                     <Col xs={6}>
                        <div className="text-smooth ts-xs">Total Sampah Terkumpul</div>
                        <h4 className={"text-light "+(loading ? "skeleton skeleton-h":"")}>{mitra?.total_trash_weight} {loading? '': 'Kg'}</h4>
                     </Col>
                     <Col xs={6}>
                        <div className="text-smooth ts-xs">Total Nasabah Terkelola</div>
                        <h4 className={"text-light "+(loading ? "skeleton skeleton-h":"")}>{mitra?.total_trash_weight} {loading? '': 'Kg'}</h4>
                     </Col>
                  </Row>
               </Card.Body>
            </Card>
         </Row>
      </div>
      <div className="p-4 bg-white">
         <div className="fw-semibold mb-3">Profil Mitra</div>
         {loading?
            <div className="skeleton skeleton-header"></div>:
            <table className="table-listed ts-ssm">
            <tbody>
               <tr>
                  <td width="130px" className="text-secondary">Pimpinan</td>
                  <td className="text-dark fw-semibold">{mitra?.manager}</td>
               </tr>
               <tr>
                  <td width="130px" className="text-secondary">Maps</td>
                  <td className="text-dark fw-semibold"><a href={`http://maps.google.com/?q=${
                      mitra?.address
                        ? mitra?.address +
                          ', ' +
                          mitra?.village.name.toLowerCase() +
                          ', ' +
                          mitra?.district.name.toLowerCase() +
                          ', ' +
                          mitra?.city.name.toLowerCase() +
                          ', ' +
                          mitra?.province.name.toLowerCase()
                        : '-'
                    }`} target="_blank">
                     Buka Maps
                    </a>
                  </td>
               </tr>
               <tr>
                  <td width="130px" className="text-secondary">Alamat</td>
                  <td className="text-dark fw-semibold">{mitra?.address}, {mitra?.village?.name}, {mitra?.district?.name}, {mitra?.city?.name}, {mitra?.province?.name}</td>
               </tr>
            </tbody>
         </table>
         }
      </div>
      <div className="p-4 bg-gray">
         <div className="text-secondary mb-3">#Trending</div>
         {newsList.length > 0 ?
            <ul className="owl p-0 pb-5">
               {newsList.map((item,key)=>{
                  return(
                     <li key={key} className={"card-news m-3 " + (key === 0 ? 'ms-4' : '')} onClick={() => navigate(`/news/${item.slug}`)}>
                        <Card>
                           <Card.Body>
                              <Image src={item.image} width="100%" height="130px" style={{objectFit:'cover', borderRadius:'10px'}}/>
                              <div className="fw-bold my-2 card-news-content">{item.title}</div>
                              <small className="wrap-ellipses" dangerouslySetInnerHTML={{ __html: item.body }} />
                           </Card.Body>
                        </Card>
                     </li>
                  )
               })}
            </ul> :
            <span className="text-default">Tidak ada berita & promo</span>         
         }
      </div>
      <div className="btn-fixed-btm">
         <div className="d-flex justify-content-between align-items-center w-100 px-4">
            <Button type="button" onClick={() => contactAdmin()} className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity">
               <i className="ph-whatsapp-logo me-2 text-success"></i> Kontak Kami
            </Button>
            {/* {mitra?.client?.length > 0 ||
               mitra?.client?.pivot?.verification_status === 'decline' && data?.clients?.length > 0 ? 
               <Button type="button" onClick={() => handleShowConfirm()} className="rounded-pill py-2 w-100" variant="success">
                  Gabung
               </Button> :
               <span>
               { mitra?.client?.pivot?.verification_status === 'success' ?
                  <Button type="button" className="rounded-pill py-2 w-100 bg-gray border-0" variant="secondary">
                     Sudah Tergabung
                  </Button> : 
                  <Button type="button" className="text-secondary rounded-pill py-2 w-100 bg-gray border-0" variant="secondary">
                     Sedang Diverifikasi
                  </Button>
               }   
               </span>
            } */}
            {loading ?
               <div className="skeleton"></div> :
               ( mitraFind ?
                     (
                        mitraFind?.pivot?.verification_status === 'pending' ?
                        <Button type="button" disabled className="rounded-pill py-2 w-50" variant="secondary">
                           Sedang diverifikasi
                        </Button> : 
                        <Button type="button" className="rounded-pill py-2 w-50" variant="success" onClick={() => handlePickUp()}>
                           Permintaan Jemput
                        </Button>
                     ) :
                     <Button type="button" onClick={() => handleShowConfirm()} className="rounded-pill py-2 w-50" variant="success">
                        Daftar
                     </Button>
               )
            }
         </div>
      </div>

      <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-4">
            <div className="my-3 text-center">
               <QuestionSvg/>
            </div>
            <div className="my-5">
               <div className="text-center">
                  Apakah Anda yakin ingin mendaftar dengan mitra ini?
               </div>
            </div>

            <div className="d-flex justify-content-between align-items-center w-100">
               <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => handleCloseCancel()}>
                  Batal
               </Button>
               <Button onClick={() => onRequestJoin()} className="rounded-pill py-2 w-50" variant="success">
                  {load ? <i className="ph-spinner spinner text-light"></i> : 'Setuju'}
               </Button>
            </div>
         </Offcanvas.Body>
      </Offcanvas>
   </div>
  );
}